import { FC } from "react";
import { useRecoilValue } from "recoil";

import {
  landingActiveStepAtom,
  LandingStepEnum,
  useLandingActions,
  useLandingLangSwitch,
} from "@ryde/utils-landings";

import {
  StepErrorHerzliya,
  StepFinishedHerzliya,
  StepLoginHerzliya,
  StepVerifyCodeHerzliya,
} from "../../steps-herzliya";

export const HerzliyaLandingStepsContainer: FC = () => {
  const step = useRecoilValue(landingActiveStepAtom);
  const { goToStep } = useLandingActions();
  useLandingLangSwitch();

  return (
    <main className="landing-outside-container">
      <div className="landing-container">
        <button
          type="button"
          className="landing-logo"
          onClick={() => goToStep(LandingStepEnum.LoginStep)}
          aria-label="Go to homepage"
        />

        {(!step || step === LandingStepEnum.LoginStep) && <StepLoginHerzliya />}
        {step === LandingStepEnum.VerificationStep && (
          <StepVerifyCodeHerzliya />
        )}
        {step === LandingStepEnum.FinishedStep && <StepFinishedHerzliya />}
        {step === LandingStepEnum.ErrorStep && <StepErrorHerzliya />}
      </div>
    </main>
  );
};
